import {ApplicationConfig} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideClientHydration} from '@angular/platform-browser';
import {provideNativeDateAdapter} from '@angular/material/core';
import {LOCALE_ID} from '@angular/core';
import localePt from '@angular/common/locales/pt';
import {registerLocaleData} from '@angular/common';
import {authInterceptor} from './core/interceptors/auth.interceptor';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideClientHydration(),
    provideNativeDateAdapter(),
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
